<template>
  <div class="gap-x-2 flex w-full">
    <ButtonWithIcon
      :label="t('challenges.tab.filter.cycle')"
      :icon="BikeIcon"
      :active="currentView === ChallengeTabType.TAB_BIKE"
      @click="setTab(ChallengeTabType.TAB_BIKE)"
    />
    <ButtonWithIcon
      :label="t('challenges.tab.filter.steps')"
      :icon="WalkIcon"
      :active="currentView === ChallengeTabType.TAB_WALK"
      @click="setTab(ChallengeTabType.TAB_WALK)"
    />
    <ButtonWithIcon
      :label="t('challenges.tab.filter.other')"
      :icon="MoreDotIcon"
      :active="currentView === ChallengeTabType.TAB_MORE"
      @click="setTab(ChallengeTabType.TAB_MORE)"
    />
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import ButtonWithIcon from "../../../components/v2/layout/button/ButtonWithIcon.vue";
import BikeIcon from "../../../components/v2/icon/BikeIcon.vue";
import WalkIcon from "../../../components/v2/icon/WalkIcon.vue";
import MoreDotIcon from "../icon/MoreDotIcon.vue";
import { ChallengeTabType } from "../../../enum/v2/challenge-tab-type";

const { t } = useI18n();
const emit = defineEmits(["update:currentTab"]);
const currentView = ref<ChallengeTabType>(null);

function setTab(tab: ChallengeTabType) {
  if (currentView.value === tab) {
    currentView.value = null;
    emit("update:currentTab", null);
  } else {
    currentView.value = tab;
    emit("update:currentTab", tab);
  }
}
</script>
